module.exports = __webpack_public_path__ + "img/none.16d36195.svg";